import React from 'react';
import Card from '../../../core/layout/Card';
import SystemTranslationLabelStatisticContainer from './SystemTranslationLabelStatisticContainer';
import Button from '../../../core/form/Button';
import SystemTranslationLocaleService from '../services/SystemTranslationLocaleService';
import SystemTranslationItemTypeInstructionStatisticContainer from './SystemTranslationItemTypeInstructionStatisticContainer';
import SystemTranslationInstructionAudioStatisticContainer from './SystemTranslationInstructionAudioStatisticContainer';
import SystemTranslationInstructionVideoStatisticContainer from './SystemTranslationInstructionVideoStatisticContainer';
import SystemTranslationEmailTemplateStatisticContainer from './SystemTranslationEmailTemplateStatisticContainer';

const SystemTranslationSummary = () => (
  <Card
    title="Summary"
    actions={<Button type="primary" icon="plus" label="Add Locale" onClick={SystemTranslationLocaleService.openForm} />}
  >
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-around',
      }}
    >
      <SystemTranslationLabelStatisticContainer />
      <SystemTranslationItemTypeInstructionStatisticContainer />
      <SystemTranslationInstructionAudioStatisticContainer />
      <SystemTranslationInstructionVideoStatisticContainer />
      <SystemTranslationEmailTemplateStatisticContainer />
    </div>
  </Card>
);

export default SystemTranslationSummary;
